/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import debounce from "lodash.debounce";
import { useMemo } from "react";
import { trackRudderstackImageEdited } from "common/utils/rudderstack/tracker.react";
import { useDtfStore } from "../store";
import { TabButton, Tabs } from "./components/Tabs/index";
import Custom from "./Custom/Custom.vue";
import DesignServices from "./DesignServices/DesignServices.vue";
import PrintAsIs from "./PrintAsIs/PrintAsIs.vue";
import PrintPerfect from "./PrintPerfect/PrintPerfect.vue";

export default function ArtworkQualityConfigPanel({
  index,
  artwork,
  reorderEnabled,
  paidExpertEditAddonEnabled,
  // @ts-expect-error TS(6133): 'activeConfigSection' is declared but its value is... Remove this comment to see the full error message
  activeConfigSection,
  isMultiUpload,
  // @ts-expect-error TS(6133): 'onSetActiveConfigSection' is declared but its val... Remove this comment to see the full error message
  onSetActiveConfigSection
}: any) {
  const store = useDtfStore();

  const debouncedToggleEnhancement = useMemo(
    () =>
      debounce(async section => {
        if (!artwork?.id) {
          return;
        }
        const enableEnhancement = section !== "print_original";
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        await store.updateEnableEnhancement({
          artworkId: artwork.id,
          enableEnhancement,
          enhancementTier: section
        });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        store.updateArtworkValuesById({
          id: artwork.id,
          hasExpertEditAddon: artwork.hasExpertEditAddon
        });
      }, 100),
    [artwork, store]
  );

  function executeTabChange(section: any) {
    if (artwork.enhancementCompleted) {
      debouncedToggleEnhancement(section);
    } else {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.updateArtworkValuesById({
        id: artwork.id,
        enhancementTier: section,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        pricing: store.cachedArtworkPrices[section] || {},
        hasExpertEditAddon: artwork.hasExpertEditAddon
      });
    }
    trackRudderstackImageEdited({
      // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
      product_line: store.sticker ? "sticker" : store.isProColor ? "pro color" : "dtf",
      artwork: {
        ...artwork,
        enhancementTier: section
      },
      edit_type: section === "print_original" ? "Print as uploaded" : "Jiffy Print Perfect",
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artworks_count: store.artworks.length,
      location: "pdp",
      // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
      pre_cut_transfers: store.preCut
    });
  }

  function setActiveConfigSection(section: any) {
    if (artwork.pinningSessionId) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.setPendingPinningInvalidation({
        type: "enhancementTier",
        artworkId: artwork.id,
        value: section
      });
      return;
    }
    executeTabChange(section);
  }

  function setPrintPerfectSection() {
    setActiveConfigSection("full_enhancements");
  }

  return (
    <>
      <Tabs
        className="artwork-quality-config-panel"
        slots={{
          buttons: () => (
            <>
              <TabButton
                active={artwork.enhancementTier === "print_original"}
                icon={undefined}
                onClick={() => {
                  setActiveConfigSection("print_original");
                }}
                data-testid="tab-button"
              >
                {"Print As Is"}
              </TabButton>
              <TabButton
                active={artwork.enhancementTier === "full_enhancements"}
                icon={"stars-corners"}
                onClick={() => {
                  setActiveConfigSection("full_enhancements");
                }}
                data-testid="tab-button-1"
              >
                {"PrintPerfect"}
              </TabButton>
              {false ? (
                <TabButton
                  active={artwork.enhancementTier === "custom"}
                  icon={undefined}
                  onClick={() => {
                    setActiveConfigSection("custom");
                  }}
                  data-testid="tab-button-2"
                >
                  {"Expert Edit"}
                </TabButton>
              ) : null}
            </>
          )
        }}
        data-testid="artwork-quality-config-panel"
      >
        {artwork.enhancementTier === "print_original" ? (
          <PrintAsIs
            key={artwork.enhancementTier}
            artwork={artwork}
            onPrintPerfectClick={setPrintPerfectSection}
            data-testid="print-as-is"
          />
        ) : null}
        {artwork.enhancementTier === "full_enhancements" ? (
          <PrintPerfect
            key={artwork.enhancementTier}
            artwork={artwork}
            reorderEnabled={reorderEnabled}
            paidExpertEditAddonEnabled={paidExpertEditAddonEnabled}
            index={index}
            data-testid="print-perfect"
          />
        ) : null}
        {!paidExpertEditAddonEnabled && artwork.enhancementTier === "custom" ? (
          <Custom
            key={artwork.enhancementTier}
            artwork={artwork}
            index={index}
            reorderEnabled={reorderEnabled}
            data-testid="custom"
          />
        ) : null}
      </Tabs>
      {artwork.enhancementTier === "full_enhancements" ||
      artwork.enhancementTier === "print_original" ? (
        <DesignServices
          artwork={artwork}
          paidExpertEditAddonEnabled={Boolean(paidExpertEditAddonEnabled)}
          index={index}
          isMultiUpload={Boolean(isMultiUpload)}
          data-testid="design-services"
        />
      ) : null}
    </>
  );
}
